/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import styles from '../styles/Home.module.css';
import { useEffect, useState } from 'react';
import { FRAuth, FRLoginFailure, FRLoginSuccess, FRStep, StepType } from '@forgerock/javascript-sdk';
import Loading from '../components/02-molecules/Loading';
import { trees } from '../config';
import AcceptTermsAndConditions from '../components/forms/common/AcceptTermsAndConditions';
import { IStageProgressBadge, StageProgressBadge } from '../components/layout/StageProgressBadge';
import FROutputCallbackBasedView from '../components/forms/common/FROutputCallBackBasedView';
import SuspendMessage from '../components/forms/common/SuspendMessage.tsx';
import { ResendLink } from '../components/forms/common/ResendLink';
import ErrorMessage from '../components/01-atoms/ErrorMessage';
// import { cloneDeep, isNil } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import { getInitialStageItems, getStageHeader } from '../util/generalUtility';
import { MessageType } from '../components/modals/SuccessErrorModal';


const tree = trees.acceptTermsAndConditions;

const TNCPage = () => {
  const [step, setStep] = useState<FRStep | FRLoginFailure | FRLoginSuccess | null>(null);
  const [tree, setTree] = useState(trees.acceptTermsAndConditions);
  const [stageItems, setStageItems] = useState<IStageProgressBadge[]>([]);
  const[stageHeaderList,setStageHeaderList] = useState<{name:string,stageName:string}[]>([])
  const [messageType, setMessageType] = useState(MessageType.info);
  const [message, setMessage] = useState('');  
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  useEffect(() => {
    (async function getStep() {
      const resumeCode = new URLSearchParams(window.location.search).get('resumeCode') || '';
      const mail = new URLSearchParams(window.location.search).get('mail') || '';
      try {
        const initialStep = await FRAuth.start({ tree, query: { resumeCode, mail } });
        if(initialStep && initialStep.type===StepType.Step){
          setStageHeaderList(getStageHeader(initialStep));
          setStageItems(getInitialStageItems(initialStep,getStageHeader(initialStep)));
        }
        setStep(initialStep);
      } catch (err) {
        console.error(`Error: request for initial step; ${err}`);
      }
    })();
  }, []);

  useEffect(() => {
    if(!isNil(step) && step && step.type === StepType.Step)
      updateStageItems(step.getStage())      
},[step]);

  const updateStageItems =(stage: string | undefined) => {
    const stageItemForUpdate = cloneDeep(stageItems);
    if(step && step.type===StepType.Step){
      stageHeaderList?.forEach((value:{name:string,stageName:string},index:number)=>{
        if(stageItemForUpdate[index].className==='active'){
          stageItemForUpdate[index].className='completed';
        }
          if(stage===value.stageName){
            stageItemForUpdate[index].className='active';
          }
          
      })
      // This logic is for back button clicks 
      stageItemForUpdate?.reverse().every((v:any,index:number)=>{
        if (stageItemForUpdate[index].className==='disabled')
        {
          return true;
        } else if(stageItemForUpdate[index].className==='active')
        {
          return false;
        }
        else if(stageItemForUpdate[index].className==='completed')
        {
          stageItemForUpdate[index].className='disabled'
          return true;
        }
    })
    }
    // setStageItems(stageItemForUpdate);
    let stageItemForUpdatefinal=stageItemForUpdate.reverse();
    setStageItems(stageItemForUpdatefinal);
  }


  const getTnCPageView = () => {
    let uiElement: JSX.Element = <Loading size={100} />;
    if (step && step.type === StepType.Step) {
      switch (step.getStage()) {
        case 'RegistrationForm':
          uiElement = <> <StageProgressBadge key={1} items={stageItems} />
            <FROutputCallbackBasedView  step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen}/></>
          break;
        case 'TermsAndConditions': 
        case 'UserTnC':
          uiElement = <> <StageProgressBadge key={2} items={stageItems} />
            <AcceptTermsAndConditions step={step as FRStep} setStep={setStep}
              tree={tree} messageType={messageType} setMessageType={setMessageType}
              message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} />
          </>
          break;
        case 'LinkResent':  
        case 'SuccessMessage':
        case 'SuspendMessage':
          uiElement = <SuspendMessage step={step as FRStep} />;
          break;
        case 'LinkExpired':
          uiElement =<ResendLink   step={step as FRStep} setStep={setStep}
          tree={tree} messageType={messageType} setMessageType={setMessageType}
          message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} />
      }
    } else if (step && step.type === StepType.LoginFailure) {
      uiElement=<ErrorMessage></ErrorMessage>
      //setUpIntialStep(step.payload.message || '');

    }
    return uiElement;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  useEffect(() => {
    if (step && step.type === StepType.LoginSuccess) {
      window.location.href = step.getSuccessUrl()!;
    };
  }), [step];

  return (
    <div className={styles.container}>
      <main className={styles.main}>
        {getTnCPageView()}
          </main>
    </div>
  );
};

export default TNCPage;
